import 'reflect-metadata';
import { jsonObject, jsonMember, toJson } from 'typedjson';

@jsonObject
@toJson
export class Phase {
  @jsonMember id!: string;
  @jsonMember name!: string;
  @jsonMember date!: string; // ISO string (facile à stocker en Dynamo)
  @jsonMember color?: string;
  @jsonMember start?: string; // ISO string
  @jsonMember end?: string; // ISO string
  @jsonMember lane?: string; // Lot / voie
}
